module.exports = __webpack_public_path__ + "static/img/Landing Page_Banner sin botón_Eureka@4x.e4cb3f34.png";